export default __webpack_public_path__ + "static/media/media-mensal.d48e493d.svg";